import { RESET_PASSWORD } from '../actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case RESET_PASSWORD:
      if (action.payload.data.success) {
        return {
          status: action.payload.data.success,
          message: action.payload.data.message
        }
      } else {
        return {
          status: action.payload.data.success,
          message: action.payload.data.error
        }
      }
  }
  return state
}
